import { Button, Collapse, Input } from 'antd-mobile';
import { DownOutline } from 'antd-mobile-icons';
import Styles from './index.module.scss';

interface IProps {
  onChange?: Function;
  value?: any;
  [index: string]: any;
}

const InputSelect = ({
  onChange,
  onClick,
  placeholder = '请输入',
  value = '',
  ...props
}: IProps) => {
  return (
    <div className={Styles.inputSelectContainer}>
      <Button
        onClick={() => onClick()}
        style={{
          '--border-color': 'none',
          width: '100%',
          padding: '0',
        }}
      >
        <div className={Styles.inputSelect}>
          {value ? (
            <div>{value}</div>
          ) : (
            <div className={Styles.placeholder}>{placeholder}</div>
          )}
          <div className={Styles.inputSelectIcon}>
            <DownOutline />
          </div>
        </div>
      </Button>
    </div>
  );
};

export default InputSelect;
